import React, {Component} from 'react';
import {Modal,Button,ButtonToolbar} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import FormJsonSchema from "react-jsonschema-form";
import { DEFAULT_SCHEMA, DEFAULT_UI_SCHEMA } from './EmployeeFilterSettingGenFormSchema'
import HrStore from 'stores/HrStore'
import {connect} from 'react-redux'
const NotificationSystem = require('react-notification-system')
class EmployeeFilterTableSettingModal extends Component {

  constructor(...args) {
    super(...args)
    
    this.state = {
      formData:this.initialData([]),
      schema:DEFAULT_SCHEMA,
      uiSchema:DEFAULT_UI_SCHEMA,
      fields:{},
      visible_fields:[]
    }
  }  
  
  initialData(visible_fields) {
    return {
        employee_id: (visible_fields.indexOf('employee_id')!==-1?true:false),
        first_name: (visible_fields.indexOf('first_name')!==-1?true:false),
        last_name: (visible_fields.indexOf('last_name')!==-1?true:false),
        nick_name: (visible_fields.indexOf('nick_name')!==-1?true:false),
        mobile: (visible_fields.indexOf('mobile')!==-1?true:false),
        address_registration: (visible_fields.indexOf('address_registration')!==-1?true:false),
        current_address: (visible_fields.indexOf('current_address')!==-1?true:false),
        gender: (visible_fields.indexOf('gender')!==-1?true:false),
        religion: (visible_fields.indexOf('religion')!==-1?true:false),
        race: (visible_fields.indexOf('race')!==-1?true:false),
        nationality: (visible_fields.indexOf('nationality')!==-1?true:false),
        height: (visible_fields.indexOf('height')!==-1?true:false),
        weight: (visible_fields.indexOf('weight')!==-1?true:false),
        marriage_status: (visible_fields.indexOf('marriage_status')!==-1?true:false),
        children: (visible_fields.indexOf('children')!==-1?true:false),
        dob_date: (visible_fields.indexOf('dob_day')!==-1||visible_fields.indexOf('dob_month')!==-1||visible_fields.indexOf('dob_year')!==-1?true:false),
        id_card: (visible_fields.indexOf('id_card')!==-1?true:false),
        ssn: (visible_fields.indexOf('ssn')!==-1?true:false),
        no_taxpayer: (visible_fields.indexOf('no_taxpayer')!==-1?true:false),
        bank_name: (visible_fields.indexOf('bank_name')!==-1?true:false),
        bank_account: (visible_fields.indexOf('bank_account')!==-1?true:false),
        start_work_date: (visible_fields.indexOf('start_work_date')!==-1?true:false),
        permanance_work_date: (visible_fields.indexOf('permanance_work_date')!==-1?true:false),
        position: (visible_fields.indexOf('position')!==-1?true:false),
        department: (visible_fields.indexOf('department')!==-1?true:false),
        work_status: (visible_fields.indexOf('work_status')!==-1?true:false),
        slip_per_month: (visible_fields.indexOf('slip_per_month')!==-1?true:false),
        exit_date: (visible_fields.indexOf('exit_date')!==-1?true:false),
        exit_reason: (visible_fields.indexOf('exit_reason')!==-1?true:false),
        exit_remark: (visible_fields.indexOf('exit_remark')!==-1?true:false),
        net_saving: (visible_fields.indexOf('net_saving')!==-1?true:false),
        slip_by: (visible_fields.indexOf('slip_by')!==-1?true:false)
    }  
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem
  }

  componentWillReceiveProps(newProps) {
    if (newProps.show&&newProps.show!==this.props.show)
      this.loadConfigEmployeeReportTable()
  }

  loadConfigEmployeeReportTable() {
    HrStore.loadConfigEmployeeReportTable((result)=>{
      this.setState({visible_fields:result.data.visible_fields,formData:this.initialData(result.data.visible_fields)})
    })
  }

  renderConfirmButton(){
      let {messages} = this.props
      return (
          <ButtonToolbar className='pull-right'>
            <Button onClick={this.onSaveClick.bind(this)} bsStyle='primary'><FontAwesome name='save'/>&nbsp;{messages['Save']}</Button>
            <Button onClick={this.props.onHide}><FontAwesome name='close'/>&nbsp;{messages['Close']}</Button>
          </ButtonToolbar>
      )
  }

  onSaveClick() {
    let {formData} = this.state
    let {messages} = this.props
    let items = []
    for (var key in formData) {
      if (formData[key]) {
        if (key==='dob_date') {
          items.push('dob_day')
          items.push('dob_month')
          items.push('dob_year')
        } else 
          items.push(key)
      }
    }
    let postData = {visible_fields:items}
    HrStore.saveConfigEmployeeReportTable(postData,(result)=>{
      if (result.status==='OK') {
        this._notificationSystem.addNotification({
          title:messages['Notice'],
          message:messages['Setting Item Save Successfully'],
          level:'info',
          position:'tc'        
        });
        this.props.onAfterSave()
      }
    },()=>{
      this.refs.notificationSystem.addNotification({
        title:messages['Notice'],
        message:messages['Setting Item Save Fail'],
        level:'error',
        position:'tc'        
      });
      this.props.onHide()
    })
  }

  onFormChange(e) {
    let {formData} = e
    let newFormData = {
        ...formData
    };   

    let new_state = {
        formData: newFormData,
    };
    this.setState(new_state)
  }

  renderGenForm() {
    let {schema,uiSchema,fields,formData,visible_fields} = this.state
    return(
        <FormJsonSchema
            schema={schema}
            uiSchema={uiSchema}
            fields={fields}
            formData={formData}
            onChange={this.onFormChange.bind(this)}
        >
            <div></div>
        </FormJsonSchema>            
    )
  }

  render(){
      let {show,messages} = this.props
      return (
        <div>
          <Modal show={show} onHide={this.props.onHide}>
            <Modal.Header closeButton>
              {messages['Setting Show Employee Information']}
            </Modal.Header>
            <Modal.Body>
              {this.renderGenForm()}
            </Modal.Body>
            <Modal.Footer>
              {this.renderConfirmButton()}
            </Modal.Footer>
          </Modal>
          <NotificationSystem ref="notificationSystem" />
        </div>
      )
  }
}


EmployeeFilterTableSettingModal.defaultProps = {
  
}

export default connect(
  (state) => ({messages: state.message.view.hr.EmployeeFilterTableSettingModal}),null,null,{withRef:true}
)(EmployeeFilterTableSettingModal);



// WEBPACK FOOTER //
// ./src/view/hr/EmployeeFilterTableSettingModal.js